import React, { useState } from "react";
import { successMsg } from "../SuccessHandler";
import ErrorCodes from "../../constants/ErrorCodes";
import SiteConfig from "../../constants/SiteConfig";
import { useInsertFunctions } from "../../functions";

const CloneLimitSetModal = ({
  data,
  idLimitSet,
  limitSetList,
  getLimitSetList,
  publicIP,
  setSessionNoLongerExists,
}) => {
  const [limitSetNameClone, setLimitSetNameClone] = useState("");
  const { cloneLimitSet } = useInsertFunctions();
  const [nameError, setNameError] = useState("");

  let limitSetName;
  limitSetList.forEach((limitSet) => {
    if (parseInt(idLimitSet) === limitSet.LimitSetID) {
      limitSetName = (
        <div
          style={{
            textAlign: "center",
          }}
          className="mt-2"
        >
          <p style={{ color: "#1cc8e3", fontWeight: "bold", fontSize: "18px" }}>
            {limitSet.LimitSetName}
          </p>
        </div>
      );
    }
  });

  const CloneLimitSetChangeHandler = (e) => {
    if (e.target.value.trim()) {
      setNameError("");
    }
    setLimitSetNameClone(e.target.value);
  };

  const handleCloneLimitSet = async () => {
    if (!limitSetNameClone.trim()) {
      setNameError("Name is required");
      return;
    }

    const res = await cloneLimitSet(
      {
        LimitSetIDCopy: idLimitSet,
        LimitSetNameNew: limitSetNameClone.trim(),
        PhoneLine: SiteConfig.LOGIN_PHONE_LINE,
        IP: publicIP,
      },
      data.LogonSessionID,
    );

    if (res?.error) {
      if (
        res.Result === ErrorCodes.InvalidSession ||
        res.Result === ErrorCodes.SessionNoLongerExists
      ) {
        setSessionNoLongerExists(true);
      }
      return;
    }

    successMsg("Limit Set Cloned");
    setLimitSetNameClone("");
    setNameError("");
    getLimitSetList();
  };

  return (
    <div>
      <div
        className="modal fade"
        id="cloneLimitSetModal"
        role="dialog"
        aria-hidden="false"
        data-keyboard="false"
        data-backdrop="static"
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.4)",
          zIndex: 1051,
        }}
      >
        <div className="modal-dialog modal-xs" style={{ margin: "4rem auto" }}>
          <div className="modal-content">
            <div
              className="modal-header"
              style={{ backgroundColor: "#5b6671", color: "#fff" }}
            >
              <h5
                className="modal-title"
                id="cloneLimitSetModal"
                style={{ cursor: "default" }}
              >
                Clone LimitSet
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                onClick={() => setLimitSetNameClone("")}
              >
                &times;
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-sm-12" style={{ cursor: "default" }}>
                  <p
                    className="lead"
                    style={{
                      color: "#8c8c8c",
                      fontSize: "16px",
                      margin: "2px",
                    }}
                  >
                    Enter the name of the LimitSet which will have the same
                    configuration as the LimitSet:
                  </p>
                  {limitSetName}
                  <div>
                    <div style={{ width: "90%", margin: "0 auto" }}>
                      <input
                        className={`form-control mt-2 ${nameError ? "is-invalid" : ""}`}
                        placeholder="Enter Name"
                        style={{ textAlign: "center" }}
                        value={limitSetNameClone}
                        onChange={CloneLimitSetChangeHandler}
                        maxLength={50}
                      />
                      {nameError && (
                        <div className="invalid-feedback text-left">
                          {nameError}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success"
                onClick={() => handleCloneLimitSet()}
              >
                Save
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => setLimitSetNameClone("")}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CloneLimitSetModal;
